// Copyright (c) Move Closer 2022.

import { VueConstructor } from 'vue'

import { ShippingMethodCode } from '../../../../../contexts'

import BaseDriver from './BaseDriver.vue'
import InPostParcelDriver from './InPostParcelDriver.vue'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const defaultDriver: VueConstructor = BaseDriver

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const driversRegistry: Record<string, VueConstructor> = {
  [ShippingMethodCode.InPostLocker]: InPostParcelDriver
}
